import {UserInputType} from '../../../../constants/stores';
import {RootStore} from '../../stores/RootStore';
import {ValidationResult} from '../../../../types/type';

export const getSubscriptionValidation = (rootStore: RootStore): ValidationResult => {
  const {isProductSubmitted, userInputErrors} = rootStore.$state;
  const isError = isProductSubmitted && userInputErrors[UserInputType.SubscriptionPlan][0];
  return {isError, errorMessage: rootStore.t.PRODUCT_PAGE_PLAN_MISSING_ERROR_TOOLTIP()};
};
